import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useHostAuth } from '../../providers/host-auth-context';

interface RequireAuthProps {
  children: ReactNode;
  redirectTo?: string;
}

export function RequireAuth({ children, redirectTo = '/' }: RequireAuthProps) {
  const { isAuthenticated } = useHostAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
